const fabricSort = (first, second) => {
    const fabricOrder = {
        proguard: 2,
        elite: 1,
        supreme: 0,
    };
    return fabricOrder[first.selectedOptions[0].value.toLowerCase()] - fabricOrder[second.selectedOptions[0].value.toLowerCase()];
};

const colorSort = (first, second) => {
    const colorOrders = {
        elite: {
            gray: -1,
            beige: 0,
            black: 1,
            'navy blue': 2,
        },
        proguard: {
            gray: -1,
            beige: 0,
            'sky blue': 1,
        },
        supreme: {
            gray: -1,
            beige: 0,
            black: 1,
            'navy blue': 2,
            'sky blue': 3,
            'coffee brown': 4,
            'red': 5
        },
    };
    const fabric = first.selectedOptions[0].value.toLowerCase();
    const colorOrder = colorOrders[fabric] || {};
    
    const firstColor = first.selectedOptions[1].value.toLowerCase();
    const secondColor = second.selectedOptions[1].value.toLowerCase();

    return (colorOrder[firstColor] ?? 0) - (colorOrder[secondColor] ?? 0);
};

const getAdjustedVariants = (product, fabric) => {
    const currentFabricVariants = product?.variants?.edges
        ?.filter((variant) => variant?.node?.selectedOptions[0].value === fabric)
        .sort((first, second) => colorSort(first?.node, second?.node));
    const firstFabricVariants = product?.variants?.edges
        ?.filter((variant) => variant?.node?.title?.includes("Gray"))
        .sort((first, second) => fabricSort(first?.node, second?.node));

    //  All variants sorted by fabric and then color
    const sortedVariants = product?.variants?.edges
        .sort((first, second) => fabricSort(first?.node, second?.node) * 3 + colorSort(first?.node, second?.node));

    // Group variants by fabric
    const groupedByFabric = Object.values(sortedVariants.reduce((acc, variant) => {
        const _fabric = variant?.node?.selectedOptions.filter((option) => option.name === "Fabric")[0]?.value;
        if (!acc[_fabric]) {
            acc[_fabric] = {
                fabric: _fabric,
                variants: [],
            };
        }
        acc[_fabric].variants.push(variant);
        return acc;
    }, {}));

    return {
        currentFabricVariants,
        firstFabricVariants,
        groupedByFabric,
    };
};

export default getAdjustedVariants;
